import { useTranslation } from "react-i18next";
import { useState, useEffect, useContext } from 'react';
import datatypes, { outboundDatatypes } from '../../constants/datatypes'
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { treeActions } from "../../redux/slices/treeSlice";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { getRePopulatedData, getRePopulatedtemplateHeader } from "../../utils/rcTreePopulate";
import DatatypeChangeWarning from "./DatatypeChangeWarning";

function DatatypeDropdown(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree} = useSelector(state => state.treeData[parentScreen]);
  const templateHeader = rightTree.tree.templateHeader;
  const [value, setValue] = useState('CSV');
  const [dropdownDisabled, setDropdownDisabled]  = useState(true);
  const [dtChangeWarning, setDtChangeWarning] = useState(false);

  const options = parentScreen === 'outbound' ? outboundDatatypes.map((v,k) => 
    <MenuItem key={k+v} value={v}>{t(v)}</MenuItem> 
  ) : datatypes.filter(ele => ( parentScreen === 'inbound' || !['EXCEL','NVP'].includes(ele))).map((v,k) => 
    <MenuItem key={k+v} value={v}>{t(v)}</MenuItem> 
  )
  
  useEffect(() => {
    if (templateHeader.FILETYPE) setValue(templateHeader.FILETYPE);
    setDropdownDisabled(!templateHeader.FILETYPE)
  }, [templateHeader.FILETYPE]);
  
  const handleChange = (e) => {
    const oldValue = value;
    if (e === "GraphQL") {
      setDtChangeWarning(true);
    } else {
      dispatch(
        treeActions.setRightTreeTemplateHeaders({
          screen: parentScreen,
          key: "FILETYPE",
          value: e,
        })
      );
      const rePopulatedData = getRePopulatedData(
        e,
        oldValue,
        templateHeader?.FILETYPE_VERSION,
        rightTree?.tree,
        parentScreen
      );
      const rePopulatedTemplateHeader = getRePopulatedtemplateHeader(
        e,
        oldValue,
        templateHeader?.FILETYPE_VERSION,
        templateHeader,
        parentScreen
      );
      dispatch(
        treeActions.setRightTreeTemplateHeader({
          screen: parentScreen,
          value: rePopulatedTemplateHeader,
        })
      );
      Object.keys(rePopulatedData)?.forEach((tab) => {
        dispatch(
          treeActions.setNewRightTreeTranslatedData({
            screen: parentScreen,
            type: tab,
            data: rePopulatedData?.[tab] || [],
          })
        );
        dispatch(
          treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            type: tab,
            data: rePopulatedData?.[tab]?.[0] || {},
          })
        );
      });
    }
  };
  
  const handleOkClick = () => {
    setDtChangeWarning(false);
    dispatch(
      treeActions.setRightTreeTemplateHeaders({
        screen: parentScreen,
        key: "FILETYPE",
        value: "GraphQL",
      })
    );
     const rePopulatedTemplateHeader = getRePopulatedtemplateHeader(
       "GraphQL",
        value,
        templateHeader?.FILETYPE_VERSION,
        templateHeader,
        parentScreen
      );
      const rePopulatedTranslatedData = getRePopulatedData(
        "GraphQL",
        value,
        templateHeader?.FILETYPE_VERSION,
        rightTree?.tree,
        parentScreen
      );
      dispatch(
        treeActions.setRightTreeTemplateHeader({
          screen: parentScreen,
          value: rePopulatedTemplateHeader,
        })
      );
      Object.keys(rePopulatedTranslatedData)?.forEach((tab) => {
        dispatch(
          treeActions.setNewRightTreeTranslatedData({
            screen: parentScreen,
            type: tab,
            data: rePopulatedTranslatedData?.[tab] || [],
          })
        );
      })
      
       dispatch(
          treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            data: rePopulatedTranslatedData?.body?.[0] || {},
            type: 'body',
          })
        );
  }

  return (
    <>
      <FormControl
        size="small"
        variant="outlined"
        className="width-100"
        disabled={dropdownDisabled}>
        <InputLabel id="dtDropdownLabel">{t("DATA_TYPE")}</InputLabel>
        <Select
          className="width-100"
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
              },
            },
          }}
          labelId="dtDropdownLabel"
          id="dtDropdown"
          value={value}
          onChange={(e) => handleChange(e.target.value)}
          label={t("DATA_TYPE")}>
          {options}
        </Select>
      </FormControl>
      {dtChangeWarning && (
        <DatatypeChangeWarning
          open={dtChangeWarning}
          onOkClick={handleOkClick}
          onClose={() => setDtChangeWarning(false)}
        />
      )}
    </>
  );
}

export default DatatypeDropdown
